export default __webpack_public_path__ + "static/media/inner-digital-organization.c895b2af.svg";